"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _debounce = _interopRequireDefault(require("@sd-utility/debounce"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _nextButton = _interopRequireDefault(require("./next-button"));
var _previousButton = _interopRequireDefault(require("./previous-button"));
var _styledTabs = require("./styled-tabs");
var _tab = _interopRequireDefault(require("./tab"));
var _tabPanel = _interopRequireDefault(require("./tab-panel"));
var _excluded = ["landOnTab", "children", "className", "dataTestId", "dataAnalyticsId", "tabChangeCallback", "tabListAriaLabel"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var useState = _react["default"].useState,
  useEffect = _react["default"].useEffect,
  useRef = _react["default"].useRef,
  useMemo = _react["default"].useMemo;
var defaultProps = {
  className: undefined,
  dataAnalyticsId: undefined,
  dataTestId: 'fuse-tabs-test-id',
  landOnTab: undefined,
  tabChangeCallback: function tabChangeCallback() {}
};
var propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  className: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  landOnTab: _propTypes["default"].number,
  tabChangeCallback: _propTypes["default"].func,
  tabListAriaLabel: _propTypes["default"].string.isRequired
};
function isDevice() {
  var _window;
  if (typeof window === 'undefined') return false;
  var isResizable = false;
  var userAgent = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent;
  if (userAgent.match(/Android/i)) {
    isResizable = true;
  } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
    isResizable = true;
  } else if (userAgent.match(/Windows Phone/i)) {
    isResizable = true;
  }
  return isResizable;
}
function Tabs(_ref) {
  var landOnTab = _ref.landOnTab,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    dataAnalyticsId = _ref.dataAnalyticsId,
    tabChangeCallback = _ref.tabChangeCallback,
    tabListAriaLabel = _ref.tabListAriaLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(landOnTab ? landOnTab - 1 : 0),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOverflow = _useState4[0],
    setIsOverflow = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showPreviousButton = _useState6[0],
    setShowPreviousButton = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showNextButton = _useState8[0],
    setShowNextButton = _useState8[1];
  var _useState9 = useState(landOnTab ? landOnTab - 1 : 0),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedIndex = _useState10[0],
    setSelectedIndex = _useState10[1];
  var tabId = useMemo(function () {
    return (0, _fuseUtils.namedUuid)('fuse-tabs-tab');
  }, []);
  var tabPanelId = useMemo(function () {
    return (0, _fuseUtils.namedUuid)('fuse-tabs-tab-panel');
  }, []);
  var tabsRef = useRef();
  var tabPanelsRef = useRef();
  var isMobileDevice = isDevice();

  /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
  var visibleTabs = function visibleTabs() {
    if (isMobileDevice) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0.99) {
          entry.target.classList.add('visible');
        } else {
          entry.target.classList.remove('visible');
        }
      });
    });
    var tabListElements = tabsRef.current.querySelectorAll('.fuse-tabs__tab-list > button');
    tabListElements.forEach(function (el) {
      io.observe(el);
    });
  };

  /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
  var tabsOverflow = function tabsOverflow() {
    var _tabsRef$current = tabsRef.current,
      scrollWidth = _tabsRef$current.scrollWidth,
      clientWidth = _tabsRef$current.clientWidth,
      scrollLeft = _tabsRef$current.scrollLeft;
    if (clientWidth < scrollWidth) {
      setIsOverflow(true);
      setShowNextButton(true);
      if (scrollLeft === 0) {
        setShowPreviousButton(false);
      } else {
        setShowPreviousButton(true);
      }
      if (!isMobileDevice) {
        tabsRef.current.querySelector('.fuse-tabs__tab-list .active').scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
      visibleTabs();
    } else {
      setIsOverflow(false);
    }
  };
  useEffect(function () {
    if (!isMobileDevice) {
      window.addEventListener('resize', tabsOverflow);
      tabsOverflow();
    }
    return function () {
      if (!isMobileDevice) {
        window.removeEventListener('resize', tabsOverflow);
      }
    };
  }, []);
  var onTabChange = (0, _react.useCallback)(function (e) {
    if (typeof tabChangeCallback === 'function') tabChangeCallback(e, tabsRef);
  }, [activeTab, tabChangeCallback]);
  var tabListScrollHandler = function tabListScrollHandler() {
    if (tabsRef.current.scrollLeft === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }
    var scrollTotal = tabsRef.current.scrollWidth - tabsRef.current.offsetWidth;
    var scrollLeftPosition = tabsRef.current.scrollLeft;
    if (scrollTotal === scrollLeftPosition || scrollLeftPosition > scrollTotal) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
    visibleTabs();
  };
  var tabClickHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, index) {
      var scrollBehavior;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setActiveTab(index);
            setSelectedIndex(index);
            if (!e.target.classList.contains('visible')) {
              scrollBehavior = isMobileDevice ? 'auto' : 'smooth';
              e.target.scrollIntoView({
                behavior: scrollBehavior,
                block: 'nearest',
                inline: 'center'
              });
            }

            /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
            visibleTabs();
            tabPanelsRef.current.children[selectedIndex].focus({
              preventScroll: true
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function tabClickHandler(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
  var previousButtonClickHandler = function previousButtonClickHandler() {
    var allVisibleTabs = tabsRef.current.querySelectorAll('.fuse-tabs__tab-list > button.visible');
    var firstVisibleTab = allVisibleTabs[0];
    firstVisibleTab.previousElementSibling.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'end'
    });
  };

  /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
  var nextButtonClickHandler = function nextButtonClickHandler() {
    var allVisibleTabs = tabsRef.current.querySelectorAll('.fuse-tabs__tab-list > button.visible');
    var lastVisibleTab = allVisibleTabs[allVisibleTabs.length - 1];
    lastVisibleTab.nextElementSibling.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  };
  var setIndex = function setIndex(index) {
    var focusOnTab = tabsRef.current.children[index];
    if (focusOnTab) {
      focusOnTab.focus();
      setSelectedIndex(index);
      setActiveTab(index);
    }
  };
  var onKeyDownHandler = function onKeyDownHandler(e) {
    var count = children.length;
    var keyMap = {
      ArrowRight: function ArrowRight() {
        return selectedIndex !== count - 1 && setIndex((selectedIndex + 1) % count);
      },
      ArrowLeft: function ArrowLeft() {
        return selectedIndex !== 0 && setIndex((selectedIndex - 1 + count) % count);
      }
    };
    var action = keyMap[e.key];
    if (action) {
      e.preventDefault();
      action();
      visibleTabs();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_styledTabs.StyledTabs, _extends({
    className: className,
    "data-testid": dataTestId || 'fuse-tabs-test-id'
  }, props), /*#__PURE__*/_react["default"].createElement(_styledTabs.StyledTabListContainer, null, /*#__PURE__*/_react["default"].createElement(_styledTabs.StyledTabList, {
    ref: tabsRef,
    onScroll: (0, _debounce["default"])(function () {
      tabListScrollHandler();
    }, 200),
    role: "tablist",
    "aria-orientation": "horizontal",
    "aria-label": tabListAriaLabel
  }, children.map(function (_ref3, index) {
    var label = _ref3.props.label;
    return /*#__PURE__*/_react["default"].createElement(_tab["default"], {
      key: label,
      id: "".concat(tabId, "-").concat(index),
      label: label,
      activeTab: activeTab === index,
      onClick: function onClick(e) {
        return tabClickHandler(e, index);
      },
      tabIndex: selectedIndex === index ? 0 : -1,
      role: "tab",
      "aria-controls": "".concat(tabPanelId, "-").concat(index),
      "aria-selected": activeTab === index ? 'true' : 'false',
      onKeyDown: onKeyDownHandler,
      "data-analyticsid": "".concat(dataAnalyticsId ? "".concat(dataAnalyticsId, " - ") : '', "Tab ").concat(index + 1, " - ").concat(label),
      onFocus: function onFocus(e) {
        return onTabChange(e, tabsRef);
      }
    });
  })), isOverflow && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_previousButton["default"], {
    onClick: previousButtonClickHandler,
    showButton: showPreviousButton
  }), /*#__PURE__*/_react["default"].createElement(_nextButton["default"], {
    onClick: nextButtonClickHandler,
    showButton: showNextButton
  }))), /*#__PURE__*/_react["default"].createElement(_styledTabs.StyledTabPanelContainer, {
    ref: tabPanelsRef
  }, children.map(function (_ref4, index) {
    var _ref4$props = _ref4.props,
      tabPanelChildren = _ref4$props.children,
      label = _ref4$props.label;
    return /*#__PURE__*/_react["default"].createElement(_tabPanel["default"], {
      key: label,
      label: label,
      activePanel: activeTab === index,
      role: "tabpanel",
      "aria-labelledby": "".concat(tabId, "-").concat(index),
      id: "".concat(tabPanelId, "-").concat(index),
      tabIndex: "0"
    }, tabPanelChildren);
  })));
}
Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
var _default = exports["default"] = Tabs;